<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="100"
    >
    
    <FormItem label="分类" prop="classify_id" v-if="classifyIds.length > 1"> 
        <Select v-model="formValidate.classify_id" clearable>
          <Option
            v-for="item in classifyIds"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>
      
      <FormItem label="选择系列" prop="seriesId">
        <Select v-model="formValidate.seriesId" clearable >
          <Option v-for="item in seriesIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>

      <FormItem label="批量上传文件">
        <input type="file" accept=".mp4,.MP4" @change="handlePathChange" ref="videoFileInput"  multiple/>

        <Button type="info" v-if='url_loadding' :loading="url_loadding">
              <span>上传中</span>
        </Button>

      </FormItem>

      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
import moment from 'moment';
const { v4: uuidv4 } = require('uuid');
import { uploadIdFile, uploadFile} from "@/api/uploadOss";
import config from '@/config'
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro


export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      classifyIds:[],
      loadding:false,
      video_show:false,
      show_path:'',
      videoSource:'',
      seriesIds:[],
      url_loadding:false,
      formValidate: {
        id: '',
        classify_id: -1,
        seriesId:'',
        path_array:[]
      },
      formValidate_org: {
        id: '',
        classify_id: -1,
        seriesId:'',
        path_array:[]
      },
      ruleValidate: {
        classify_id: [
          {
            required: true,
            message: '分类必须选择',
            trigger: 'change'
          }
        ],seriesId: [
          {
            required: true,
            message: '系列必须选择',
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    async handlePathChange(e) {
      try{
        const files = e.target.files;
        if (files.length == 0) return;
        for (var i = 0; i < files.length; i++){
            this.url_loadding = true;
            var file = files[i]
            let currentDate = moment().format('YYYY-MM-DD');
            const uuid = uuidv4()
            // 上传文件
            var name = file.name.substring(file.name.lastIndexOf('.'))

            var result = ''
            if (baseUrl == 'https://in.sinano-ai.com/api'){
              result = await uploadIdFile('short_video/' + currentDate + "/short_video_task/" + uuid + name, file);
              this.formValidate.path_array.push(result)
            }else{
              result = await uploadFile('short_video/' + currentDate + "/short_video_task/" + uuid + name, file);
              this.formValidate.path_array.push(result)
            }

            if (result != '') {
              this.$Message.info('上传成功');
            } else {
              this.$Message.error('上传失败');
            }

        }
        this.url_loadding = false;
      } catch (error) {
        this.url_loadding = false;
        this.$Message.error('上传失败');
      }

    },
    setSeries(classify_list){
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.seriesIds = data
    },
    setClassifyData (classify_list) {
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.classifyIds = data
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {

      if (this.$refs.videoFileInput != null)
        this.$refs.videoFileInput.value = ''
      this.formValidate.path_array = []
      this.formValidate = { ...this.formValidate_org }
      this.$refs[name].resetFields()
    }
    
  }
}
</script>
